import {Component, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import {Logger} from '@common-lib';
import {ActivatedRoute} from '@angular/router';
import {PluginGotenehusProductRegionsService} from '../../pages-services/plugin-gotenehus-product-regions.service';
import {ToasterService} from 'angular2-toaster';
import {TranslateService} from "@ngx-translate/core";
import {ConfirmPopupComponent} from "../../components/confirm-popup/confirm-popup.component";

@Component({
    selector: 'app-plugin-product-gotenehus-regions',
    templateUrl: './plugin-gotenehus-product-regions.component.html',
    styleUrls: ['./plugin-gotenehus-product-regions.component.scss']
})
export class PluginGotenehusProductRegionsComponent implements OnInit {
    editModalRef: BsModalRef;
    selectedRow: {
        id: number,
        regionId: number,
        productId: number,
        regionName: string,
        productName: string,
        price: number
    };
    searchTerm = '';

    @ViewChild('editFormTemplate')
    editFormTemplate: TemplateRef<any>;

    tableConfiguration = {
        searchEnabled: false,
        headerEnabled: true,
        orderEnabled: true,
        globalSearchEnabled: false,
        paginationEnabled: true,
        exportEnabled: false,
        clickEvent: false,
        selectRow: false,
        selectCol: false,
        selectCell: false,
        rows: 50,
        additionalActions: false,
        serverPagination: false,
        isLoading: false,
        detailsTemplate: false,
        groupRows: false,
        paginationRangeEnabled: true,
        collapseAllRows: false,
        checkboxes: false
    };

    columns = [
        {key: 'id', title: 'ID'},
        {key: 'regionName', title: 'Region'},
        {key: 'productName', title: 'Product'},
        {key: 'price', title: 'price'},
        {key: 'actions', title: ''}
    ];

    data = [];
    rows = [];
    selected = new Set();
    selectedLocale = 'en-EN';

    @ViewChild(ConfirmPopupComponent)
    confirmPopup: ConfirmPopupComponent;

    constructor(
        private route: ActivatedRoute,
        private pluginGotenehusProductRegionsService: PluginGotenehusProductRegionsService,
        private modalService: BsModalService,
        private logger: Logger,
        private toasterService: ToasterService,
        private translationService: TranslateService) {
    }

    ngOnInit() {
        this.getList();
    }

    getList() {
        this.pluginGotenehusProductRegionsService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    localeChanged() {
        this.pluginGotenehusProductRegionsService.getList().subscribe((data) => {
            this.data = data;
            this.search();
        });
    }

    editRow(row) {
        this.selectedRow = row;
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }

    rowSelected(event) {
        if (event.event === 'onDoubleClick') {
            this.editRow(event.value.row);
        }
    }

    async saveData() {
        let sendObj = Object.assign({}, this.selectedRow);

        if (!sendObj.id) {
            this.pluginGotenehusProductRegionsService
                .create(sendObj)
                .subscribe(async (result) => {
                    this.getList();
                    this.toasterService.pop('success', '', await this.translationService.get('webpanel.plugin_gotenehus_product_regions.created_message').toPromise());
                    this.editModalRef.hide();
                }, (err) => {
                    this.toasterService.pop('error', '', err.message);
                });
        } else {
            this.pluginGotenehusProductRegionsService
                .update(sendObj.id, sendObj)
                .subscribe((result) => {
                    this.pluginGotenehusProductRegionsService
                        .getList()
                        .subscribe(async (data) => {
                            this.data = data;
                            this.search();
                            this.toasterService.pop('success', '', await this.translationService.get('webpanel.plugin_gotenehus_product_regions.updated_message').toPromise());
                            this.editModalRef.hide();
                        });
                });
        }
    }

    search() {
        this.rows = this.data.filter((r) => this.searchTerm.length === 0 ||
            (r.productName && r.productName.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1) ||
            (r.regionName && r.regionName.toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1)
        );
    }

    /*
    addNew() {
        this.selectedRow = {
            id: null,
            regionId: null,
            productId: null,
            price: 0
        };
        this.editModalRef = this.modalService.show(this.editFormTemplate);
    }
    */

    searchKeyPress(event) {
        if (event.which === 13) {
            this.search();
        }
    }

    async removeItem(item) {
        this.selectedRow = item;
        if (this.selectedRow) {
            this.confirmPopup.show();
        }
    }

    confirm(res) {
        if(res) {
            if (this.selectedRow) {
                this.pluginGotenehusProductRegionsService.delete(this.selectedRow).subscribe(async (resp) => {
                    this.selectedRow = null;
                    let successMessage = await this.translationService.get('webpanel.plugin_gotenehus_product_regions.delete.success_message').toPromise();
                    this.toasterService.pop('success', '', successMessage);
                    this.getList();
                });
            }
        }else{
            this.selectedRow = null;
        }
    }

    decline() {
        this.selectedRow = null;
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/plugin-gotenehus-product-regions/plugin-gotenehus-product-regions.component.ts